export const getEdadFromFecha = (fechaIso) => {
  if (!fechaIso) return "";

  const birth = new Date(fechaIso);
  if (Number.isNaN(birth.getTime())) return "";

  const today = new Date();
  let edad = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    edad--;
  }

  return edad > 0 ? `${edad} años` : "";
};

export const getTelefonoPrincipal = (telefonosRaw) => {
  if (!telefonosRaw) return "";

  const partes = telefonosRaw.split("|").filter(Boolean);
  if (!partes.length) return "";

  const primera = partes[0];
  const [, numero] = primera.split(",");
  return (numero || primera || "").trim();
};

export const toDateInputValue = (isoDate) => {
    if (!isoDate) return "";
    const d = new Date(isoDate);
    if (Number.isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const day = String(d.getDate()).toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  


  export const toNumber = (v) => {
    if (v === null || v === undefined) return 0;
    const n = Number(String(v).replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };
  
 export const formatRD = (num) =>
    `RD$ ${Number(num || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  
  export const displayRD = (v) => {
    if (v === null || v === undefined || v === "") return "";
    const n = toNumber(v);
    return formatRD(n);
  };